import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { DateRange } from 'react-day-picker';

import format from 'date-fns/format';

import { handleRangeSelect } from './handleRangeSelect';
import { Range } from './selectCustomRangeHandler';
import { RangeValue } from './types';

type UseCombineRangeInputValue = {
  isRHFConnected?: boolean;
  dateFormat: string;
  defaultValue?: DateRange;
  valueFromRHF?: RangeValue;
  setActiveRange: Dispatch<SetStateAction<Range | null>>;
  setSelectedRange: Dispatch<SetStateAction<DateRange | undefined>>;
};

/** To make focus stay in place when type value manually, focus is going to be placed at the end
 * if we use value not from onChange event.target.value */
export const useCombineRangeInputValue = ({
  valueFromRHF,
  setActiveRange,
  isRHFConnected,
  setSelectedRange,
  dateFormat,
  defaultValue,
}: UseCombineRangeInputValue) => {
  const [fromValue, setFromValue] = useState<string>(
    valueFromRHF?.from || (defaultValue?.from ? format(defaultValue.from, dateFormat) : '')
  );
  const [toValue, setToValue] = useState<string>(
    valueFromRHF?.to || (defaultValue?.to ? format(defaultValue.to, dateFormat) : '')
  );

  useEffect(() => {
    if (isRHFConnected) {
      if (valueFromRHF) {
        // If different value was provided by RHF we set this value
        if (valueFromRHF.from !== fromValue || valueFromRHF.to !== toValue) {
          handleRangeSelect(
            valueFromRHF.from && valueFromRHF.to
              ? {
                  from: new Date(valueFromRHF.from),
                  to: new Date(toValue),
                }
              : undefined,
            {
              setToValue,
              setFromValue,
              setSelectedRange,
              dateFormat,
            }
          );
        }
      } else {
        // If reset
        handleRangeSelect(undefined, {
          setToValue,
          setFromValue,
          setSelectedRange,
          dateFormat,
        });
      }

      /** Reset active range */
      setActiveRange(null);
    }
  }, [valueFromRHF?.from, valueFromRHF?.to]);

  return { fromValue, toValue, setFromValue, setToValue };
};
